import { createFileRoute } from "@tanstack/react-router";

import ShipMetalForm from "../-components/ShipMetal/ShipMetalForm";

export const Route = createFileRoute("/_authenticated/trade/ship-metal/product-list")({
  component: ShipMetalForm,
  context: () => ({ permissions: "trade.ship" }),
});
